import { gql } from '@apollo/client';

export const SEARCH_TRACKING_LOGIN = gql`
    mutation SearchTrackingLogin($trackingLogin: TrackingLogin!) {
        searchTrackingLogin(trackingLogin: $trackingLogin)
    }
`;
